import { render, staticRenderFns } from "./YoutubeVideoCard.vue?vue&type=template&id=2b4c886c&scoped=true&"
import script from "./YoutubeVideoCard.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c886c",
  null
  
)

export default component.exports